import SupportMentorCalendar from 'src/supportPortal/components/common/mentor/mentorCalendar/SupportMentorCalendar'

export default function DoctorBookings() {
  return (
    <SupportMentorCalendar dontOpenReports getSingleMentorApiSignature="/api/secure/cc/support/doctor/by-slug" />
  )
}
